module.exports = __webpack_public_path__ + "static/img/84046B_1_B_20220618_LC.a0c0396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84046B_1_B_20220618_LC.png
// module id = V6bS
// module chunks = 0